import React, { useState } from "react";
import { Container, Button, Modal } from "react-bootstrap";
import { FaFilePdf, FaEye, FaDownload } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// Import PDF documents
import guarantorsDoc from "../components/Files/GUARANTORS_REPLACEMENT_FORM.pdf";
import membershipDoc from "../components/Files/Membership_application_Form 2025.pdf";
import newLoanDoc from "../components/Files/NEW_LOAN_APPLICATION_FORM-7.pdf";
import booksOfAccountDoc from "../components/Files/SACCO_AUDITED_BOOKS_OF_ACCOUNTS_2023.pdf";
import saccoMembershipProfile from "../components/Files/SACCOMEMBERSHIP_PROFILE_UPDATE_FORM.pdf";
import withdrawable from "../components/Files/WITHDRWABLE_DEPOSIT_ACCOUNT_ACTIVATION_FORM.pdf";

const documents = [
  { id: 1, name: "Guarantors Replacement Form", url: guarantorsDoc },
  { id: 2, name: "Membership Application Form", url: membershipDoc },
  { id: 3, name: "New Loan Application Form", url: newLoanDoc },
  { id: 4, name: "Sacco Audited Books of Accounts 2023", url: booksOfAccountDoc },
  { id: 5, name: "Sacco Membership Profile Update Form", url: saccoMembershipProfile },
  { id: 6, name: "Withdrawable Deposit Account Activation Form", url: withdrawable },
];

const DownloadDocuments = () => {
  const [showModal, setShowModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePreview = (url) => {
    setPreviewUrl(url);
    setShowModal(true);
  };

  return (
    <>
      <Navbar />
      <Container className="py-5">
        <h2 className="text-center text-dark mb-4">Download Documents</h2>
        <p className="text-center text-muted">
          Click <b>Preview</b> to read the file, or <b>Download</b> to save it.
        </p>

        {/* Grid Layout for Document Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-5">
          {documents.map((doc) => (
            <div key={doc.id} className="p-6 bg-white rounded-lg shadow-lg text-center">
              <FaFilePdf size={48} className="text-danger mb-3" color="red" />
              <h3 className="text-lg font-semibold text-gray-800">{doc.name}</h3>
              <div className="flex justify-center gap-3 mt-4">
                <Button variant="outline-primary" onClick={() => handlePreview(doc.url)}>
                  <FaEye className="me-2" color="green" /> Preview
                </Button>
                <Button variant="outline-secondary" onClick={() => handleDownload(doc.url)}>
                  <FaDownload className="me-2" /> Download
                </Button>
              </div>
            </div>
          ))}
        </div>
      </Container>

      {/* Preview Modal with Close Button on the Right and Centered Vertically */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Document Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex align-items-center">
          {/* PDF Preview */}
          {previewUrl.endsWith(".pdf") ? (
            <iframe
              src={previewUrl}
              width="85%"
              height="500px"
              title="PDF Preview"
              className="rounded-lg"
            ></iframe>
          ) : (
            <p>Document preview is only available for PDFs.</p>
          )}
          {/* Close Button Beside the Document (Right & Centered) */}
          <Button
            variant="danger"
            onClick={() => setShowModal(false)}
            className="ms-3"
            style={{ height: "50px" }} // Adjust height to match middle alignment
          >
            Close
          </Button>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};

export default DownloadDocuments;
